export default class AccordionComponent {
	constructor() {
		const accordionBtns = document.querySelectorAll(".accordion-title");

		accordionBtns.forEach(function (accordion) {
			accordion.addEventListener('click', function () {
				this.classList.toggle('is-open');

				let content = this.nextElementSibling;

				if (content.style.maxHeight) {
					content.style.maxHeight = null;
				} else {
					content.style.maxHeight = content.scrollHeight + "px";
				}
			});
		});
		
	}

}
new AccordionComponent();